<template>
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.6663 36.6683C24.0301 36.6683 29.9997 30.6986 29.9997 23.3346C29.9997 15.9707 24.0301 10.001 16.6663 10.001C9.30255 10.001 3.33301 15.9707 3.33301 23.3346C3.33301 25.3939 3.7998 27.3441 4.63334 29.0852C4.91983 29.6836 5.02042 30.3616 4.84893 31.0025L4.30219 33.046C3.87127 34.6566 5.3447 36.13 6.95526 35.6991L8.99865 35.1523C9.63956 34.9809 10.3175 35.0814 10.9159 35.3679C12.657 36.2015 14.6072 36.6683 16.6663 36.6683Z"
            stroke="currentColor"
            stroke-width="1.6"
        />
        <path
            d="M29.9987 24.1709C30.1095 24.1247 30.2194 24.0767 30.3282 24.027C30.9317 23.7513 31.6088 23.6482 32.2497 23.8197L33.0431 24.032C34.6537 24.4629 36.1271 22.9894 35.6962 21.3788L35.4839 20.5854C35.3124 19.9445 35.4155 19.2674 35.6912 18.6639C36.3168 17.2943 36.6654 15.7717 36.6654 14.1676C36.6654 8.18435 31.8151 3.33398 25.832 3.33398C21.3283 3.33398 17.4664 6.08236 15.832 9.99348"
            stroke="currentColor"
            stroke-width="1.6"
        />
        <path
            d="M10.8646 23.335H10.8796M16.6825 23.335H16.6975M22.5008 23.335H22.5158"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "ChatIcon",
});
</script>
